import { render, staticRenderFns } from "./SliderRangeInput.vue?vue&type=template&id=255f510c&"
import script from "./SliderRangeInput.vue?vue&type=script&lang=js&"
export * from "./SliderRangeInput.vue?vue&type=script&lang=js&"
import style0 from "./SliderRangeInput.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRangeSlider } from 'vuetify/lib/components/VRangeSlider';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VRangeSlider,VRow,VTextField})
